import { Layout } from './Layout';

import { useSetRecoilState } from 'recoil';

import { CartItemEventHandler } from '../../types';
import { isCartModalOpenState } from '../../../Header/atoms';

import { IconButton } from '../../../GlobalComponents/IconButton';
import PlusIcon from '../../../assets/imgs/icon/Plus.svg';
import MinusIcon from '../../../assets/imgs/icon/Minus.svg';
import EditIcon from '../../../assets/imgs/icon/edit.svg';

export type ButtonsProps = React.HTMLAttributes<HTMLDivElement> & {
	id: string;
	onEdit: CartItemEventHandler;
	onDuplicate: CartItemEventHandler;
	onDelete: CartItemEventHandler;
};

export const Buttons: React.FC<ButtonsProps> = ({
	id,
	onEdit,
	onDuplicate,
	onDelete,
	...props
}) => {
	const setIsCartModalOpen = useSetRecoilState(isCartModalOpenState);
	return (
		<Layout
			delete={
				<IconButton
					url={MinusIcon}
					alt={'Remove'}
					width={24}
					height={24}
					onClick={() => onDelete(id)}
				/>
			}
			duplicate={
				<IconButton
					url={PlusIcon}
					alt={'Add'}
					width={24}
					height={24}
					onClick={() => onDuplicate(id)}
				/>
			}
			edit={
				<IconButton
					url={EditIcon}
					alt={'Edit'}
					width={24}
					height={24}
					onClick={() => {
						setIsCartModalOpen(false);
						onEdit(id);
					}}
				/>
			}
			divProps={{
				...props,
				className: `cart-buttons${
					props.className ? ` ${props.className}` : ''
				}`
			}}
		/>
	);
};
